import Label from "./Label";

const UpperDetails = ({ concert: { month, day, season, label }, t }) => {
  return (
    <div className="concert-upper-details">
      <div className="concert-date-group">
        <h6 className="uppercasebold1 m-0">{t(`concerts.${month}`)}</h6>
        <h3 className="uppercasebold1 mmi-day-title m-0">{day}</h3>
      </div>
      <Label season={season} label={label} t={t} />
    </div>
  );
};

export default UpperDetails;

